import React from 'react';
import banner from 'assets/photos/effy.jpg';
import BlurViewer from 'components/BlurViewer';
import './banner.scss';

function Banner() {
  return (
    <section>
      <BlurViewer image={banner} className='intro'>
        <div className='intro-inner'>
          <div className='col-center'>
            <h4 className='intro-message'>
              <div className='intro-message-text current' data-till-hour='11'>
                HEY, GOOD DAY!
              </div>

              <div className='intro-message-text' data-till-hour='17'>
                HEY, GOOD afternoon!
              </div>

              <div className='intro-message-text' data-till-hour='24'>
                HEY, GOOD evening!
              </div>
            </h4>
            <h2 className='intro-title'>Welcome to Effy's Site.</h2>
          </div>
        </div>
      </BlurViewer>
    </section>
  );
}

export default Banner;
